import { reRegionConstants } from './constants'

const initialState =
{
	isSending   : false,
	list        : [],
	listByRoles : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case reRegionConstants.GetList.REQUEST:
		case reRegionConstants.GetListForRoles.REQUEST:
			return {
				...state,
				isSending : true
			}
		case reRegionConstants.GetList.FAILURE:
		case reRegionConstants.GetListForRoles.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case reRegionConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reRegionConstants.GetListForRoles.SUCCESS:
			return {
				...state,
				isSending   : false,
				listByRoles : action.payload.result
			}
		case reRegionConstants.CLEAR:
			return {
				...state,
				isSending   : false,
				list        : [],
				listByRoles : {}
			}
		default:
			return state
	}
}